import { apiClient } from "@/shared/api/client";
import type { EarningsSummary } from "@/features/earnings/types";

export async function fetchMyEarnings(): Promise<EarningsSummary> {
  const { data } = await apiClient.get<EarningsSummary>("/earnings/me");
  return data;
}
